import React, { useContext } from 'react';
import { RouteComponentProps } from '@reach/router';
import { ButtonTextTransform } from 'react-magma-dom';
import {
  StyledColoredLine,
  StyledNotFoundBtn,
  StyledNotFoundContent,
  StyledNotFoundHeading,
  StyledNotFoundImg,
  StyledNotFoundText,
  StyledNotFoundWrapper,
} from '../../components/Styled';
import AuthContext from '../../contexts/authContext';
import { COLORS, EMERGENT, EXEMPLARS } from '../../constants';
import girlImage from '../../assets/girl-upside-down.png';

export const NotFound: React.FC<RouteComponentProps> = props => {
  const { navigate } = props;

  const { isTrialAccess } = useContext(AuthContext);

  const openHomePage = () => {
    navigate && navigate(`/${EXEMPLARS}/${EMERGENT}`);
  };

  return (
    <>
      <StyledColoredLine color={COLORS.mainGradient} />
      <StyledNotFoundWrapper withBanner={isTrialAccess} data-testid="not-found">
        <StyledNotFoundContent>
          <StyledNotFoundHeading>Oops!</StyledNotFoundHeading>
          <StyledNotFoundText>We can&apos;t seem to find the page you&apos;re looking for.</StyledNotFoundText>
          <StyledNotFoundBtn textTransform={ButtonTextTransform.none} onClick={openHomePage} testId="not-found-btn">
            Home
          </StyledNotFoundBtn>
        </StyledNotFoundContent>
        <StyledNotFoundImg src={girlImage as string} alt="Not found" />
      </StyledNotFoundWrapper>
    </>
  );
};
